import React from 'react';
import BaseOutlierCountAlert from "./BaseOutlierCountAlert";

const RecordsCountOutlier = () => {
    return <BaseOutlierCountAlert accessor={'record'} alertType={'Record'} threshold={25}/>;
};

export default RecordsCountOutlier;